"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptiveToolbar = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@veeam/core");
const helpers_1 = require("../../../helpers");
const Toolbar_1 = require("../..");
const CustomToolbarItem_1 = require("../CustomToolbarItem/CustomToolbarItem");
const DefaultToolbarItem_1 = require("../DefaultToolbarItem/DefaultToolbarItem");
const GroupToolbarItem_1 = require("../GroupToolbarItem/GroupToolbarItem");
const ToolbarContainer_1 = require("../ToolbarContainer/ToolbarContainer");
const defaultGroupDecorator_1 = require("../../helpers/defaultGroupDecorator");
const processItem_1 = require("../../helpers/processItem");
const getOtherActionsControl_1 = require("../../hooks/helpers/getOtherActionsControl");
const useAdaptiveLayout_1 = require("../../hooks/useAdaptiveLayout");
const types_1 = require("../../types");
exports.AdaptiveToolbar = (0, helpers_1.createUIElement)('AdaptiveToolbar', (_a, ref) => {
    var { className, items, groups = [], payload = {}, disabled, view, buildIn, onMouseEnter, onMouseLeave, style, testIdValue, dataEatIndent } = _a, rest = __rest(_a, ["className", "items", "groups", "payload", "disabled", "view", "buildIn", "onMouseEnter", "onMouseLeave", "style", "testIdValue", "dataEatIndent"]);
    const toolbarRef = ref !== null && ref !== void 0 ? ref : (0, react_1.useRef)(null);
    const toolbarItems = (0, react_1.useMemo)(() => {
        const checkedItems = items.filter((item) => Boolean(item));
        return [...checkedItems, (0, getOtherActionsControl_1.getOtherActionsControl)(checkedItems)].filter((item) => Boolean(item));
    }, [items]);
    const itemsRefs = (0, react_1.useRef)(Array(items.length + 1)
        .fill(0)
        .map(() => (0, react_1.useRef)(null)));
    const { canAction } = (0, core_1.useGuard)();
    const adaptiveItems = (0, useAdaptiveLayout_1.useAdaptiveLayout)(toolbarRef, itemsRefs, toolbarItems).map((item) => (Object.assign(Object.assign({}, item), { disabled: disabled || item.disabled })));
    const processedItems = (0, react_1.useMemo)(() => (0, defaultGroupDecorator_1.defaultGroupDecorator)(adaptiveItems, groups, payload || null, canAction)
        .map((itemProps) => (0, processItem_1.processItem)(payload, itemProps, canAction))
        .filter((item) => Boolean(item)), [adaptiveItems, canAction, groups, payload]);
    return (react_1.default.createElement(ToolbarContainer_1.ToolbarContainer, { ref: toolbarRef },
        react_1.default.createElement(Toolbar_1.ToolbarLayout, Object.assign({}, rest, { style: Object.assign({ width: '100%' }, style), testId: testIdValue, view: view, buildIn: buildIn, "data-toolbar": true, "data-eat-indent": dataEatIndent, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: (0, helpers_1.cn)('vm-Toolbar', className) }), processedItems.map((itemProps, idx) => {
            const key = `${itemProps.type}-${itemProps.id || idx}`;
            const itemRef = itemsRefs.current[idx];
            if (itemProps.type === types_1.TOOLBAR_ITEM_TYPE.customControl) {
                return (react_1.default.createElement(CustomToolbarItem_1.CustomToolbarItem, { ref: itemRef, key: key, itemProps: itemProps }));
            }
            if (itemProps.type === types_1.TOOLBAR_ITEM_TYPE.group) {
                return (react_1.default.createElement(GroupToolbarItem_1.GroupToolbarItem, { ref: itemRef, key: key, itemProps: itemProps }));
            }
            return react_1.default.createElement(DefaultToolbarItem_1.DefaultToolbarItem, { ref: itemRef, key: key, itemProps: itemProps });
        }))));
});
//# sourceMappingURL=AdaptiveToolbar.js.map